import { FC } from 'react'

import { SelectBox } from '../SelectBox'
export type CDN = 'Akamai' | 'Fastly'
export const CDN_SELECT_TEST_ID = 'cdn-select' as const

const CDN_OPTIONS: CDN[] = ['Akamai', 'Fastly']

type Props = {
  value: CDN | null
  onChange: (value: CDN | null) => void
  onClear?: () => void
  label?: string
  testId?: string
  getOptionId?: (option: CDN) => string
}

export const CdnSelect: FC<Props> = ({ onChange, ...props }) => {
  return (
    <SelectBox
      label="CDN"
      testId={CDN_SELECT_TEST_ID}
      onClear={() => onChange(null)}
      onChange={onChange}
      {...props}
      options={CDN_OPTIONS}
      clearable
    />
  )
}
